export const product_promo_sale_methods = {
  clear_sale_form_errors() {
    this.promo_errors.sale_discount_type = null;
    this.promo_errors.sale_discount_value = null;
    this.promo_errors.sale_start_date = null;
    this.promo_errors.sale_end_date = null;
  },
  get_sale_discount_value() {
    return parseFloat(this.sale_discount_value);
  },
  get_sale_percentage_discount_type() {
    return this.discount_types.find(
      (type) => String(type.name || type.label).toLowerCase() === "percentage",
    );
  },
  is_sale_percentage_discount_over_limit(sale_discount_value) {
    const percentage_type = this.get_sale_percentage_discount_type();
    if (!percentage_type) return false;
    if (String(this.sale_discount_type) !== String(percentage_type.id)) return false;
    return sale_discount_value > 100;
  },
  is_sale_end_date_before_start_date() {
    if (!this.sale_start_date) return false;
    if (!this.sale_end_date) return false;

    const start_time = new Date(this.sale_start_date).getTime();
    const end_time = new Date(this.sale_end_date).getTime();
    return end_time <= start_time;
  },
  is_invalid_sale_discount_value(sale_discount_value) {
    return this.sale_discount_value === "" || Number.isNaN(sale_discount_value) || sale_discount_value <= 0;
  },
  get_required_sale_discount_type_error() {
    return this.sale_discount_type ? null : {
      field: "sale_discount_type",
      message: "Sale discount type is required.",
    };
  },
  get_sale_discount_value_error(sale_discount_value) {
    return this.is_invalid_sale_discount_value(sale_discount_value) ? {
      field: "sale_discount_value",
      message: "Sale discount value must be greater than 0.",
    } : null;
  },
  get_sale_percentage_limit_error(sale_discount_value) {
    return this.is_sale_percentage_discount_over_limit(sale_discount_value) ? {
      field: "sale_discount_value",
      message: "Sale percentage cannot exceed 100%.",
    } : null;
  },
  get_required_sale_start_date_error() {
    return this.sale_start_date ? null : {
      field: "sale_start_date",
      message: "Sale start date is required.",
    };
  },
  get_required_sale_end_date_error() {
    return this.sale_end_date ? null : {
      field: "sale_end_date",
      message: "Sale end date is required.",
    };
  },
  get_sale_date_order_error() {
    return this.is_sale_end_date_before_start_date() ? {
      field: "sale_end_date",
      message: "Sale end date must be after the start date.",
    } : null;
  },
  get_sale_validation_errors(sale_discount_value) {
    return [
      this.get_required_sale_discount_type_error(),
      this.get_sale_discount_value_error(sale_discount_value),
      this.get_sale_percentage_limit_error(sale_discount_value),
      this.get_required_sale_start_date_error(),
      this.get_required_sale_end_date_error(),
      this.get_sale_date_order_error(),
    ].filter(Boolean);
  },
  validate_sale_form() {
    this.clear_sale_form_errors();

    const validation_errors = this.get_sale_validation_errors(this.get_sale_discount_value());
    validation_errors.forEach((error) => {
      this.promo_errors[error.field] = error.message;
    });

    return validation_errors.length === 0;
  },
  get_sale_target_payload() {
    if (this.sale_applies_all) return { applies_all: true };

    return ({
      product_ids: (this.selected_sale_products || [])
        .map((product) => Number(product?.id))
        .filter(Boolean),
    });
  },
  build_sale_payload(extra = {}) {
    return Object.assign({
      discount_type_id: this.sale_discount_type,
      discount_amount: this.sale_discount_value,
      start_date: this.sale_start_date || null,
      end_date: this.sale_end_date || null,
      is_active: this.sale_is_active,
    }, this.get_sale_target_payload(), extra);
  },
  submitProductSale() {
    this.create_product_sales();
  },
};
